import { FC, memo } from "react";
import { PRIMARY_BLUE, TERTIARY_ORANGE, TERTIARY_PURPLE } from "@/theme";
import { StyledOrderState, StyledOrderStateText } from "./OrderState.styled";

import { ORDER_STATE } from "@/types";
import { OrderStateProps } from "./OrderState.interface";
import StateIcon from '@/assets/icons/Status';
import { getOrderStateText } from "@/helpers";

const getStateText = (state: ORDER_STATE): string => {
  return getOrderStateText(state);
}

const getStateColor = (state: ORDER_STATE) => {
  switch (state) {
    case ORDER_STATE.RETURN_TO_WORK:
    case ORDER_STATE.BOOKING_IN_PROGRESS: {
      return TERTIARY_ORANGE.DEFAULT;
    }
    case ORDER_STATE.BOOKING_PLACED:
    case ORDER_STATE.AWAITING_CARD_PAYMENT:
    case ORDER_STATE.AWAITING_DATE:
    case ORDER_STATE.AWAITING_PAYMENT: {
      return TERTIARY_PURPLE.DEFAULT;
    }
    case ORDER_STATE.CONTENT_SELECTED:
    case ORDER_STATE.ORDER_PAID:
    case ORDER_STATE.COMPLETE:
    case ORDER_STATE.CANCELLED:
    case ORDER_STATE.DRAFT: {
      return PRIMARY_BLUE.DARK
    }
  }
}

const OrderState: FC<OrderStateProps> = ({ state }) => {
  const stateMessage = getStateText(state);
  const stateColor = getStateColor(state);

  return (
    <StyledOrderState color={stateColor}>
      <StateIcon />
      <StyledOrderStateText>{stateMessage}</StyledOrderStateText>
    </StyledOrderState>
  );
}

export default memo(OrderState);
